/* RustGo storefront behaviour: lazy video playback, gallery, packs, tabs, sticky bar, reveal. */
(function () {
  var doc = document.documentElement;
  doc.classList.add('rg-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* Videos only load and play while on screen; paused off screen to save data on mobile. */
  function initVideos(root) {
    var vids = (root || document).querySelectorAll('video[data-rg-src]');
    if (!('IntersectionObserver' in window)) {
      vids.forEach(function (v) { v.src = v.dataset.rgSrc; });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (!v.src) { v.src = v.dataset.rgSrc; }
          if (!reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { rootMargin: '200px 0px', threshold: 0.15 });
    vids.forEach(function (v) { if (!v.__rg) { v.__rg = 1; io.observe(v); } });
  }

  window.RGInitVideos = initVideos;

  function initReveal() {
    var els = document.querySelectorAll('.rg-rv');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initTabs() {
    document.querySelectorAll('[data-rg-tabs]').forEach(function (wrap) {
      var tabs = wrap.querySelectorAll('[role="tab"]');
      function select(tab) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on);
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        initVideos(wrap);
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t); });
        t.addEventListener('keydown', function (e) {
          var k = e.key, n = null;
          if (k === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
          if (k === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
          if (n) { e.preventDefault(); n.focus(); select(n); }
        });
      });
    });
  }

  function initGallery() {
    document.querySelectorAll('[data-rg-gallery]').forEach(function (g) {
      var track = g.querySelector('.rg-gal__track');
      var thumbs = g.querySelectorAll('.rg-gal__thumb');
      if (!track) return;
      thumbs.forEach(function (b, i) {
        b.addEventListener('click', function () {
          track.scrollTo({ left: track.clientWidth * i, behavior: reduce ? 'auto' : 'smooth' });
        });
      });
      var t;
      track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          thumbs.forEach(function (b, j) { b.setAttribute('aria-current', j === i); });
          if (thumbs[i]) thumbs[i].scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }, 60);
      }, { passive: true });
    });
  }

  /* Pack picker writes the quantity into the product form and updates every price label. */
  function initPacks() {
    document.querySelectorAll('[data-rg-buy]').forEach(function (buy) {
      var form = buy.querySelector('form[action*="/cart/add"]');
      var qty = form && form.querySelector('input[name="quantity"]');
      var labels = document.querySelectorAll('[data-rg-price-now]');
      var was = document.querySelectorAll('[data-rg-price-was]');
      buy.querySelectorAll('input[name="rg-pack"]').forEach(function (r) {
        r.addEventListener('change', function () {
          if (!r.checked) return;
          if (qty) qty.value = r.value;
          labels.forEach(function (l) { l.textContent = r.dataset.now; });
          was.forEach(function (l) { l.textContent = r.dataset.was || ''; });
        });
      });
    });
  }

  function initSticky() {
    var bar = document.querySelector('[data-rg-stick]');
    var anchor = document.querySelector('[data-rg-buy] form');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
    });
    io.observe(anchor);
    bar.querySelector('button').addEventListener('click', function () {
      var submit = anchor.querySelector('[type="submit"]');
      if (submit) submit.click();
    });
  }

  onReady(function () {
    initVideos();
    initReveal();
    initTabs();
    initGallery();
    initPacks();
    initSticky();
  });
  document.addEventListener('shopify:section:load', function () {
    initVideos(); initReveal(); initTabs(); initGallery(); initPacks();
  });
})();
